/* =================== PAGAMENTO =================== */
jQuery(document).ready(function ($) {
  // Forma de envio
  $('input[name="forma-entrega"]').on("change", function () {
    var forma = $(this).val().split("|");
    var nomeForma = forma[0];
    var valorForma = forma[1];
    var valorPedido = $("#valorPagtoOriginal").val();
    var valorPedidoVista = $("#valorPagtoAvista").val();
    var maxParcelas = $("#max_parcelas").val();
    var desconto = $("#valor_c_desconto").data("param");

    var novoValorPedido = parseFloat(valorPedido) + parseFloat(valorForma);
    var novoValorPedidoAvista =
      parseFloat(valorPedidoVista) + parseFloat(valorForma);

    var percentual_desconto = desconto / 100.0;
    var valor_desconto = valorPedido * percentual_desconto;

    var valor_pedido = novoValorPedido;
    var valor_vista = novoValorPedidoAvista;

    console.log(valor_pedido);
    console.log(maxParcelas);
    var parcelas = valor_pedido / maxParcelas;

    //Output
    $("#valorPagto").val(valor_pedido);
    $("#valorPagtoVista").val(valor_vista);
    $("#forma_frete").html(nomeForma);
    $("#valor_frete").html("R$ " + formataMoeda(valorForma));
    //$("#total_prazo").html("R$ "+formataMoeda(valorPedido));
    $("#parcelas_pedido").html(formataMoeda(parcelas));
    //$("#valor_c_desconto").html("R$ -"+formataMoeda(valor_desconto));
    $("#total_prazo").html("R$ " + formataMoeda(valor_pedido));
    $("#final_pedido").html("R$ " + formataMoeda(valor_vista));

    $("#mostra_frete").show();
    
    function parcelamento(total, parcelas) {
      const infosParcelamento = {
        total: total,
        parcelas: parcelas
      };
      $.ajax({
        type: "POST",
        url: url_geral + "acoes/app/pagarme/parcelamento.php",
        data: infosParcelamento,
        async: false,
        cache: false,
        success: function (response) {
          console.log(response);
          const campoParcela = $('#parcelas');
          let installments = $.parseJSON(response);
          console.log(installments);
          if (installments.length > 0) {
            $("#parcelas").html("");
            $("#parcelas").append('<option value="" hidden>Parcelas</option>');
            for (let item in installments) {
              if (installments[item].installment <= parcelas) {
                let interestFree = installments[item].interestFree;
                if (typeof installments[item].interestFree === 'string' && installments[item].interestFree === 'false') {
                  interestFree = false;
                }
                const installmentFree = interestFree ? ' (sem juros)' : ' (R$ '+formataMoeda(installments[item].amount)+')';
                campoParcela.append(
                  `<option value="${installments[item].installment}x${installments[item].installment_amount}">${
                    installments[item].installment
                  }x de R$ ${formataMoeda(installments[item].installment_amount)}${installmentFree} </option>`,
                );
              }
            }
          }
        },
      });
    }
    
    let parcelasEnv = $('#parcelas_limite').val();
    let total_compraEnv = $('#valorPagto').val();
    parcelamento(total_compraEnv, parcelasEnv);

    /* //parcelamento
    if ($("#bandeira").val() != "") {
      //parcelamento
      var sem_juros =
        $("#max_parcelas").val() > 1 ? $("#max_parcelas").val() : "";

      var parcelas_limite = $("#parcelas_limite").val();

      if (sem_juros > 1) {
        PagSeguroDirectPayment.getInstallments({
          amount: valor_pedido,
          brand: $("#bandeira").val(),
          maxInstallmentNoInterest: sem_juros,
          success: function (response) {
            console.log(response.installments);
            $("#parcelas").html("");
            $("#parcelas").append('<option value="">Parcelas</option>');
            $.each(response.installments, function (index, value) {
              $.each(value, function (index, value) {
                if (parcelas_limite >= ++index) {
                  var juros = this.interestFree == true ? "( Sem juros )" : "";
                  $("#parcelas").append(
                    '<option value="' +
                      this.quantity +
                      "x" +
                      this.installmentAmount +
                      '">' +
                      this.quantity +
                      "X de R$ " +
                      formataMoeda(this.installmentAmount) +
                      " = R$ " +
                      formataMoeda(this.totalAmount) +
                      " " +
                      juros +
                      "</option>"
                  );
                }
              });
            });

            $(".msg_invalido").hide();
          },
          error: function (response) {
            console.log(response.errors);
            console.log(amount);
            var dataString = {
              origem: "parcelamento",
              msg: response.errors,
              acao: "log",
            };
            $.ajax({
              type: "POST",
              url: url_geral + "acoes/app/pagamentos/grava_log.php",
              data: dataString,
              cache: false,
              success: function (response) {},
            });
          },
          complete: function (response) {},
        });
      } else {
        PagSeguroDirectPayment.getInstallments({
          amount: valor_pedido,
          brand: $("#bandeira").val(),
          success: function (response) {
            console.log(response.installments);
            $("#parcelas").html("");
            $("#parcelas").append('<option value="">Parcelas</option>');
            $.each(response.installments, function (index, value) {
              $.each(value, function (index, value) {
                if (parcelas_limite >= ++index) {
                  var juros = this.interestFree == true ? "( Sem juros )" : "";
                  $("#parcelas").append(
                    '<option value="' +
                      this.quantity +
                      "x" +
                      this.installmentAmount +
                      '">' +
                      this.quantity +
                      "X de R$ " +
                      formataMoeda(this.installmentAmount) +
                      " = R$ " +
                      formataMoeda(this.totalAmount) +
                      " " +
                      juros +
                      "</option>"
                  );
                }
              });
            });

            $(".msg_invalido").hide();
          },
          error: function (response) {
            console.log(response.errors);
            console.log(amount);
            var dataString = {
              origem: "parcelamento",
              msg: response.errors,
              acao: "log",
            };
            $.ajax({
              type: "POST",
              url: url_geral + "acoes/app/pagamentos/grava_log.php",
              data: dataString,
              cache: false,
              success: function (response) {},
            });
          },
          complete: function (response) {},
        });
      }
    }
    //parcelamento */
  });
});
